import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider }      from '@/contexts/AuthContext';
import { WarehouseProvider } from '@/contexts/WarehouseContext';
import App from './App';

import '@/styles/global.css';
import '@/styles/dashboard.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <WarehouseProvider>
          <App />
        </WarehouseProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
